import { render, staticRenderFns } from "./Distritos.vue?vue&type=template&id=01f20d6e&scoped=true"
import script from "./Distritos.vue?vue&type=script&lang=ts"
export * from "./Distritos.vue?vue&type=script&lang=ts"
import style0 from "./Distritos.vue?vue&type=style&index=0&id=01f20d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f20d6e",
  null
  
)

export default component.exports